import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { ReactComponent as MessageDoubleCheckIcon } from 'assets/img/message-double-check.svg';
import { ReactComponent as MessageSingleCheckIcon } from 'assets/img/message-single-check.svg';
import { formatMessageDate, formatAMPM } from '../../../../../../helpers/utils';
import { useStores } from 'stores';
import styles from '../../../ChatWindow.module.scss';

const OwnMessage = observer(({ message, showDate }) => {
  const {
    messageStore: { lastReadMessageAnotherUser },
  } = useStores();

  const today = new Date();
  const messageDate = message.added;

  const renderDate = useCallback(
    () => (
      <p className={styles['message-date']}>
        {today.toDateString() === messageDate.toDateString() ? 'Today' : formatMessageDate(message.added)}
      </p>
    ),
    [message, messageDate, today]
  );

  return (
    <div className={cn(styles['message-wrapper'], styles['right-margin'])}>
      <div>
        {showDate && renderDate()}

        <div className={cn(styles.message, styles['my-message'])}>
          <p className={styles['message-text']}>{message.text}</p>
          <div className={styles['message-meta']}>
            <span className={styles['message-time']}>{formatAMPM(message.added)}</span>
            <span
              className={cn(styles['message-status'], {
                [styles['message-status--read']]: lastReadMessageAnotherUser >= message.id,
              })}
            >
              {lastReadMessageAnotherUser >= message.id ? <MessageDoubleCheckIcon /> : <MessageSingleCheckIcon />}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

OwnMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number,
    conversationId: PropTypes.number,
    userId: PropTypes.string,
    userFirstName: PropTypes.string,
    userLastName: PropTypes.string,
    added: PropTypes.instanceOf(Date).isRequired,
    text: PropTypes.string,
  }).isRequired,
  showDate: PropTypes.bool.isRequired,
};

export default OwnMessage;
